export default "__VITE_ASSET__4esxhw5d__"